import React from 'react';
import BaseHeader from "./BaseHeader";

export default function CarListHeader(props) {

    const filter = props.filter;

    const params = filter.params;

    const makeArr = Object.keys(params.selectedMakes);
    const make = makeArr && makeArr.length ? makeArr[0] : null;

    const modelArr = make && params.selectedMakes[make]['models']
        ? Object.keys(params.selectedMakes[make]['models']) : null;
    const model = modelArr && modelArr.length ? modelArr[0] : null;

    const trimArr = make && model && params.selectedMakes[make]['models'][model]['trim']
        ? Object.keys(params.selectedMakes[make]['models'][model]['trim']) : null;
    const trim = trimArr && trimArr.length ? trimArr[0] : null;

    const locationParts = params.location ? params.location.split(',') : null;

    const city = locationParts ? locationParts[0] : null;

    const state = locationParts && locationParts[1] ? locationParts[1] : null;

    return <BaseHeader
        header={<>Used{make ? ' '+make : ' cars'}{model ? ' '+model : ''}{trim ? ' '+trim : ''} for sale
        {city ? ' in '+city : ''}{state ? ', '+state : ''}</>}
        location={params.zipCode}
        isMobile={props.isMobile}
        exitUrl={null}
        handleItemExit={null}
        path={[
            make ? {url: "/used-cars/"+make, label: make} : null,
            model ? {url: "/used-cars/"+make+','+model, label: model} : null,
            trim ? {url: "/used-cars/"+make+','+model+';'+trim, label: trim} : null,
        ]}
        sideContent={props.sideContent}
    />;
}


